'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var EventType = {
    // Pre-transfer event
    PreTransfer: 'transfer.preTransfer',

    // Mid-transfer events
    ObjectFullMove: 'transfer.midTransfer.objectFullMove',
    ObjectFullSkip: 'transfer.midTransfer.objectFullSkip',
    ObjectPartInit: 'transfer.midTransfer.objectPartInit',
    ObjectPartMove: 'transfer.midTransfer.objectPartMove',
    ObjectPartSkip: 'transfer.midTransfer.objectPartSkip',
    ObjectPartSync: 'transfer.midTransfer.objectPartSync',

    // Post-transfer events
    // Post-transfer events
    PostTransfer: 'transfer.postTransfer',
    StorageClientPostTransfer: 'transfer.storageclient.done',
    StorageServerPostTransfer: 'transfer.storageserver.done'
};

var TRANSFER_EVENTS = 'transfer.events';

var isTerminalEvent = function isTerminalEvent(transferEvent) {
    return transferEvent === EventType.ObjectFullMove || transferEvent === EventType.ObjectFullSkip;
};

module.exports = {
    StatusCode: {
        Success: 'SUCCESS',
        Failure: 'FAILURE'
    },

    EventType: _extends({}, EventType, {
        isTerminalEvent: isTerminalEvent
    }),

    EventMatcher: {
        MidTransfer: 'transfer.midTransfer.*'
    },

    TRANSFER_EVENTS: TRANSFER_EVENTS
};